import { html } from "lit";
var icon_digital_content_default = () => html`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g fill-rule="evenodd">
      <path
        fill-rule="nonzero"
        d="M21.682 4.287H7.364a.657.657 0 00-.657.656v17.5c0 .363.294.657.657.657h14.318a.657.657 0 00.656-.657v-17.5a.656.656 0 00-.656-.656zM21.026 5.6v16.187H8.02V5.599h13.006z" />
      <path
        d="M12.9 12.675a.647.647 0 00-.935.579v4.37a.648.648 0 00.935.579l4.371-2.186a.646.646 0 000-1.156L12.9 12.675z" />
      <path
        fill-rule="nonzero"
        d="M15.318 1.105c1.197 0 2.175.936 2.244 2.116l.003.132v1.59a.656.656 0 01-1.307.083l-.005-.083v-1.59a.935.935 0 00-.84-.93l-.095-.005H4.182a.935.935 0 00-.93.839l-.005.096V17.67c0 .484.368.882.84.93l.095.004h3.182a.657.657 0 01.082 1.307l-.082.006H4.182a2.248 2.248 0 01-2.244-2.115l-.003-.132V3.353c0-1.197.935-2.175 2.115-2.244l.132-.004h11.136z" />
      <path
        fill-rule="nonzero"
        d="M12.534 7.728a.563.563 0 01.85.732l-.054.063-1.591 1.591c-.2.2-.513.218-.733.054l-.063-.054-.795-.795a.563.563 0 01.732-.85l.063.054.397.398 1.194-1.193z" />
    </g>
  </svg>
`;
export {
  icon_digital_content_default as default
};
//# sourceMappingURL=icon-digital-content.js.map
